import { render, staticRenderFns } from "./HistoryConversations.vue?vue&type=template&id=f99f762e&scoped=true"
import script from "./HistoryConversations.vue?vue&type=script&lang=js"
export * from "./HistoryConversations.vue?vue&type=script&lang=js"
import style0 from "./HistoryConversations.vue?vue&type=style&index=0&id=f99f762e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99f762e",
  null
  
)

export default component.exports